import React from 'react';
import Form, { Actions, RequiredValidator, TextField } from '../../../Components/Form';
import { useOnboarding } from '../OnboardingProvider';
import StepShell, { nextSubmit } from '../Components/StepShell';

const BusinessNameStep = () => {
    const {draft, updateStepData, next, back} = useOnboarding();

    return <StepShell
        title="What's your business called?"
        intro="This appears on your quotes, invoices and website. Don't worry, you can change it later."
    >
        <Form
            data={draft.data.businessName}
            onChange={(data) => updateStepData('businessName', data)}
            onSubmit={() => next()}
        >
            <TextField
                label="Business name"
                name="name"
                placeholder="e.g. Shiny Windows"
                validators={[RequiredValidator]}
            />
            <Actions submit={nextSubmit} cancel={{label: 'Back', onClick: back}} />
        </Form>
    </StepShell>;
};

export default BusinessNameStep;
